export { default } from './InputTooltip';
